import { InternalAxiosRequestConfig } from 'axios';

import { tokenService } from '@/auth/services/TokenService';

/**
 * Axios request interceptor that automatically attaches JWT tokens to outgoing requests.
 * The token is added as a Bearer token in the Authorization header.
 *
 * @param config - The axios request configuration
 * @returns The modified request configuration with Authorization header
 */
export async function authInterceptor(
  config: InternalAxiosRequestConfig,
): Promise<InternalAxiosRequestConfig> {
  if (config.headers.Authorization) {
    return config;
  }

  try {
    const token = await tokenService.getAccessToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
  } catch (error) {
    console.error('Failed to attach auth token:', error);
  }

  return config;
}
